$(document).ready(function() {

    if ($('.custom-select-radios').length) {
      setupCustomSelects();
    }

    function setupCustomSelects() {
      // Custom selects
      $('.custom-select-radios button').on('click', function() {
        $(this).parent().toggleClass('active');
        $(this).toggleClass('active');
        $('.custom-select-radios ul').scrollTop(0);
      });

      $('.custom-select-wrapper .custom-select-radios ul li label').on('click', function(e) {
        $(this).parent().parent().parent().find('button').text($(this).text());
        $(this).parent().parent().parent().removeClass('active');
        e.stopPropagation();
      });

      $('.custom-select-radios.filter ul li label, .custom-select-radios.pages ul li label').on('click', function(e) {
        $(this).parent().parent().parent().removeClass('active');
        $(this).parent().parent().parent().find('button').removeClass('active');
        e.stopPropagation();
      });

      $('.custom-select-radios.pages ul li label').on('click', function(e) {
        $(this).parent().parent().parent().find('button').text($(this).text());
        e.stopPropagation();
      });

      // When there's wrapped ones
      $('.js-bttn-filter-wrapper').on('click', function() {
          $(this).next().toggleClass('active');
          $(this).toggleClass('active');
          $('.custom-select-radios').not($(this).next()).removeClass('active');
      });
    }
  });
